module.exports = __webpack_public_path__ + "static/media/dm.d065af05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/dm.svg
// module id = 101
// module chunks = 0